import { createSlice } from '@reduxjs/toolkit';
import {fetchManagerBuildings, maintenanceLogin} from "./actions";

const adminSlice = createSlice({
    name: 'manager',
    initialState: {
        buildings: { buildings: [], partner: {} },
        buildingsPending: false,
        livyIframeToken: { pending: false, data: null, error: null },
        tab: null
    },
    reducers: {
        changeTab: (state, action) => {
            state.tab = action.payload;
        }
    },
    extraReducers: builder => {
        builder.addCase(fetchManagerBuildings.fulfilled, (state, action) => {
            state.buildings = action.payload;
            state.buildingsPending = false;
        });
        builder.addCase(fetchManagerBuildings.rejected, (state, action) => {
            state.buildings = { buildings: [], partner: {} };
            state.buildingsPending = false;
            console.error(action.payload);
        });
        builder.addCase(fetchManagerBuildings.pending, (state, action) => {
            state.buildingsPending = true;
        });
        builder.addCase(maintenanceLogin.pending, (state, action) => {
            state.livyIframeToken = { pending: true, data: null, error: null };
        });
        builder.addCase(maintenanceLogin.fulfilled, (state, action) => {
            state.livyIframeToken = { pending: false, data: action.payload, error: null };
        });
        builder.addCase(maintenanceLogin.rejected, (state, action) => {
            state.livyIframeToken = { pending: false, data: null, error: action.payload };
        });
    },
});

export const {
    changeTab
} = adminSlice.actions;
export default adminSlice.reducer;
